import { Component, EventEmitter, Input, Output } from '@angular/core';
import { language } from 'src/app/shared/models/language.model';
import { EnvironmentService } from 'src/app/shared/services/environment/environment.service';
import { TranslationService } from "src/app/shared/services/translation/translation.service";

@Component({
  selector: 'app-header-translator',
  standalone: false,
  templateUrl: './header-translator.component.html',
  styleUrl: './header-translator.component.scss'
})
export class HeaderTranslatorComponent {
  @Input() title: string = '';
  @Input() textContent: string = '';
  @Input() anchorHref: string = '';
  @Input() anchorText: string = '';
  @Output() languageSelected = new EventEmitter<string>();

  lang = language;
  constructor(
    public translationService: TranslationService,
    private environmentService: EnvironmentService
  ) {}
    
  getTitle() : string {
    if (this.title === '') {
      return this.environmentService.getTitle();
    }
    return this.title;    
  }

  useLanguage(selectedlanguage: string) : void {
      this.translationService.useLanguage(selectedlanguage);
      this.languageSelected.emit(selectedlanguage);
  }
}
